function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18.5c-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.384 11.525a80.384 80.384 0 00-1.538-.442l-.488-.139c-.665-.195-1.002-.54-1.002-1.022 0-.77.843-1.172 1.675-1.172 1.09 0 1.793.662 1.793 1.687h1.5c0-1.604-1.047-2.824-2.573-3.117V6h-1.5v1.333c-1.406.279-2.395 1.295-2.395 2.589 0 1.175.758 2.072 2.08 2.461l.504.143c.508.143 1.24.349 1.491.428.988.313.988.8.988 1.085 0 .679-.79 1.21-1.8 1.21-1.068 0-2.15-.601-2.15-1.749h-1.5c0 1.583 1.15 2.825 2.781 3.155V18h1.5v-1.301c1.538-.236 2.67-1.318 2.67-2.659 0-1.189-.743-2.106-2.036-2.515z",
  fill: "currentColor"
});

function SvgPricePerSqftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPricePerSqftIcon;